/*
 * Cart drawer (sections/cart-drawer.liquid).
 *
 * - Opens from the header bag icon (except on the cart page itself) and after
 *   an item is added on the product page (product.liquid fires 'cart:updated').
 * - Quantity, remove and "Complete the look" adds go through the AJAX Cart API
 *   with `sections: 'cart-drawer'`, so Shopify returns the freshly rendered
 *   drawer in the same response and the HTML is swapped in place.
 */
(function () {
  var SECTION = 'cart-drawer';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.cd__panel');
  var lastFocus = null;
  var busy = false;

  function isOpen() { return drawer.classList.contains('is-open'); }

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    setTimeout(function () { panel.focus(); }, 50);
  }

  function close() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Swap in freshly rendered drawer HTML and sync the header bag count.
  function render(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd-inner]');
    var current = drawer.querySelector('[data-cd-inner]');
    if (!fresh || !current) return;
    var scroll = current.querySelector('.cd__scroll');
    var scrollTop = scroll ? scroll.scrollTop : 0;
    current.parentNode.replaceChild(fresh, current);
    var newScroll = fresh.querySelector('.cd__scroll');
    if (newScroll) newScroll.scrollTop = scrollTop;

    var count = parseInt(fresh.getAttribute('data-item-count'), 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('d-none', count === 0);
    });
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: count, source: SECTION } }));
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data[SECTION]); });
  }

  function post(url, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function showError(scope, err) {
    var msg = (err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.';
    var el = scope && scope.querySelector('[data-cd-error]');
    if (!el) { window.alert(msg); return; }
    el.textContent = msg;
    el.hidden = false;
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { close(); return; }

    var arrow = e.target.closest('[data-cd-scroll]');
    if (arrow) {
      var track = drawer.querySelector('.cd-upsells__track');
      if (track) track.scrollBy({ left: parseInt(arrow.getAttribute('data-cd-scroll'), 10) * 324, behavior: 'smooth' });
      return;
    }

    var qtyBtn = e.target.closest('[data-cd-qty]');
    if (qtyBtn && !busy) {
      var item = qtyBtn.closest('[data-cd-key]');
      busy = true;
      item.classList.add('is-loading');
      post('/cart/change.js', { id: item.getAttribute('data-cd-key'), quantity: parseInt(qtyBtn.getAttribute('data-cd-qty'), 10) })
        .then(function (cart) { render(cart.sections && cart.sections[SECTION]); })
        .catch(function (err) { item.classList.remove('is-loading'); showError(item, err); })
        .then(function () { busy = false; });
      return;
    }

    var addBtn = e.target.closest('[data-cd-up-add]');
    if (addBtn && !busy) {
      var card = addBtn.closest('[data-cd-upsell]');
      var variant = card.querySelector('[data-cd-up-variant]');
      if (!variant || !variant.value) return;
      busy = true;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      post('/cart/add.js', { items: [{ id: parseInt(variant.value, 10), quantity: 1 }] })
        .then(function (res) { render(res.sections && res.sections[SECTION]); })
        .catch(function (err) {
          addBtn.disabled = false;
          addBtn.textContent = 'Add';
          window.alert((err && err.description) || 'Sorry, we couldn’t add that item.');
        })
        .then(function () { busy = false; });
    }
  });

  // Mobile bottom sheet: drag the handle or header down to close. The sheet
  // follows the finger; releasing past a quarter of its height (or a quick
  // flick) closes it, otherwise it springs back.
  var mobileMq = window.matchMedia('(max-width: 767px)');
  var overlay = drawer.querySelector('.cd__overlay');
  var drag = null;

  panel.addEventListener('pointerdown', function (e) {
    if (!mobileMq.matches || !isOpen() || e.pointerType === 'mouse') return;
    if (!e.target.closest('[data-cd-handle], .cd__header') || e.target.closest('button, a')) return;
    drag = { id: e.pointerId, y0: e.clientY, t0: Date.now(), dy: 0 };
    panel.setPointerCapture(e.pointerId);
    drawer.classList.add('is-dragging');
  });

  panel.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    drag.dy = Math.max(0, e.clientY - drag.y0);
    panel.style.transform = 'translateY(' + drag.dy + 'px)';
    overlay.style.opacity = String(Math.max(0, 1 - drag.dy / panel.offsetHeight));
  });

  function endDrag(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var speed = drag.dy / Math.max(1, Date.now() - drag.t0);
    var shouldClose = drag.dy > panel.offsetHeight * 0.25 || (speed > 0.6 && drag.dy > 30);
    drag = null;
    drawer.classList.remove('is-dragging');
    panel.style.transform = '';
    overlay.style.opacity = '';
    if (shouldClose) close();
  }
  panel.addEventListener('pointerup', endDrag);
  panel.addEventListener('pointercancel', endDrag);

  // Show the chosen variant's photo on an upsell card, and enable Add once
  // a required choice (e.g. a letter) has been made.
  drawer.addEventListener('change', function (e) {
    var select = e.target.closest('select[data-cd-up-variant]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var card = select.closest('[data-cd-upsell]');
    var add = card.querySelector('[data-cd-up-add]');
    if (add) add.disabled = !select.value;
    var img = card.querySelector('[data-cd-up-img]');
    if (img && opt && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    // Keep keyboard focus inside the drawer while it is open.
    var focusable = panel.querySelectorAll('a[href], button:not([disabled]), select, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Header bag icons open the drawer, except on the cart page.
  var onCartPage = /^\/cart\/?$/.test(window.location.pathname);
  if (!onCartPage) {
    document.querySelectorAll('[data-cart-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        refresh().catch(function () {});
        open();
      });
    });
  }

  // Product page add-to-bag: re-render and slide the drawer in.
  window.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.source === SECTION) return;
    refresh().then(function () { if (!onCartPage) open(); }).catch(function () {});
  });

  window.CartDrawer = { open: open, close: close, refresh: refresh };
})();
